import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export default {
    state: {
        pvz_selected:'0;0',  // выбранный пункт самовывоза tk_id;pvz_id
        pvz_obj_selected: null, // выбранный пункт самовывоза объект
        deliv_type_group : 'todoor', // тип группы доставки,
        deliv_type_id: '0', // тип доставки
        deliv_region_id : '0',
        deliv_city_id : '0',
        deliv_country : '',
        deliv_region : '',
        deliv_city : '',
        deliv_zip : '',
        deliv_day: null,
        deliv_day_sam: null,
        deliv_interval: null,
        user_info: '',
        pay_type: '',
        require_address: false,
        require_passport: false,
        pvzs: [],
        coordinates: {lat:0, lon:0}
    },
    mutations,
    actions,
    getters
}
